.Bar
    width: 100%
    height: 60px
    padding: 0 20px
    display: flex
    flex-shrink: 0
    flex-direction: row
    align-items: center
    box-sizing: border-box
    position: relative
    .Left
        display: flex
        flex-grow: 1
        flex-basis: 0
        font-size: 16px
        font-weight: 700
        .Ellipsis
            min-width: 0
            display: -webkit-box
            -webkit-line-clamp: 2
            -webkit-box-orient: vertical
            text-align: left
            text-overflow: ellipsis
            overflow: hidden
            word-wrap: break-word
    .Center
        position: relative
        height: 30px
        display: flex
        justify-content: center
        align-items: center
        .HideOnMobile
            @media #{$mobile}
                display: none
        .CenterField
            height: 100%
            display: flex
            justify-content: center
            align-items: center
            cursor: pointer
            color: rgb($globalSettingsFontSecondary)
            padding: 5px 10px
            border-radius: $globalButtonRounding
            &:hover
                color: rgb($globalSettingsFontPrimary)
                background: rgb($globalSettingsBackgroundSecondary)
        .CenterFieldWaiting
            opacity: 0.7
            cursor: wait
            &:hover
                color: rgb($globalSettingsFontSecondary)
                background: rgb($globalSettingsBackgroundPrimary)
        .LeftField
            position: absolute
            width: 20px
            height: 30px
            top: 0
            left: -25px
        .RightField
            position: absolute
            width: 20px
            height: 30px
            top: 0
            right: -25px

    .Right
        flex-grow: 1
        flex-basis: 0
        display: flex
        justify-content: flex-end

.ButtonContainer
    stroke: rgb($globalSettingsFontSecondary)
    cursor: pointer
    &:hover
        stroke: rgb($globalSettingsFontTertiary)

.Clickable
    cursor: pointer

@media #{$tablet}
    .Bar
        height: 80px
        padding: 0 30px
        .Left
            font-size: 18px
            font-weight: 400
